import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Button,
  Row,
  Col,
  Uploader,
  DatePicker,
  Dropdown,
  Checkbox,
  Modal,
  Input,
  SelectPicker,
  Content,
  Container,
} from 'rsuite'

export default function BookingManagementScholarsForm({ schema, loading, Controller, ...props }) {
  const { register, handleSubmit, errors, control, setError, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [fromSchema, setFromSchema] = useState(schema)

  return (
    <>
      <Panel loading={loading}>
        <Row style={{ marginTop: 20 }}>
          <Col lg={6} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {fromSchema.projectType.label}
          </Col>
          <Col lg={18} md={16} sm={24} xs={24}>
            <SelectPicker
              searchable={false}
              data={fromSchema.projectType.options}
              value={props.value}
              block
              placeholder="เลือก"
              // onChange={(value) => {
              //   props.onChange(value)
              // }}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 20 }}>
          <Col lg={6} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {fromSchema.note.label}
          </Col>
          <Col lg={18} md={16} sm={24} xs={24}>
            <Input componentClass="textarea" placeholder={'ระบุ'} />
          </Col>
        </Row>
      </Panel>

      <Row
        style={{
          marginTop: 20,
          textAlign: 'right',
        }}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <Button appearance="primary" style={{ marginRight: 10 }}>
            ขออนุมัติ
          </Button>
          <Button color="blue" appearance="primary">
            ยกเลิก
          </Button>
        </Col>
      </Row>
    </>
  )
}
